import { createRoomStatusObservable, } from '../../util/create_room_status_observable';
import { validateConfigShape } from '../../util/validate_config_shape';
import { ARController } from '../controllers/ar_controller';
import { RoomSession } from './room_session';
import { CameraSubject } from 'streem-sdk-protobuf';
export class SpectatorRoomSession extends RoomSession {
    static async initialize(config) {
        return new SpectatorRoomSession(config, await super.buildWallSyncClient(config));
    }
    constructor(config, wallSyncClient) {
        super(config, wallSyncClient);
        this.config = config;
        validateConfigShape(['onEnd', 'localUserId', 'localDeviceId', 'remoteUserId', 'remoteDeviceId', 'roomId'], config);
        this.ar = new ARController({
            ...this.controllerConfig,
            mediaController: this.media,
            deleteLocalItemsOnRemoteCameraSubjectChange: true,
        });
        this.status = createRoomStatusObservable(this.room.roomStatus, this.room.localParticipantStatus, this.room.remoteParticipantStatus, this.invitationController.incomingInvitationStatus);
    }
    async connectToRoom() {
        await this.connect();
        await this.media.createSpectatorTracks();
        await this.media.connect(this.config.roomId, this.config.localUserId);
    }
}
SpectatorRoomSession.canSendCameraSubjects = [
    CameraSubject.CAMERA_SUBJECT_PERSON,
];
//# sourceMappingURL=spectator_room_session.js.map